import { TextFieldModule } from '@angular/cdk/text-field';
import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { ContainsValidDynamicContentDirective } from '@vendasta/shared';
import { Subscription } from 'rxjs';

import { EmailPreviewRefreshService } from '../../services/email-preview-refresh.service';

// Interface
export interface HtmlBlock {
  rawHtml: string;
}

// Default blank value
export const blankHtmlBlock: HtmlBlock = {
  rawHtml: `<div style="font-size: 14px">

</div>`,
};

@Component({
  selector: 'email-html-block',
  templateUrl: './html-block.component.html',
  styleUrls: ['./html-block.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    MatInputModule,
    TextFieldModule,
    TranslateModule,
    GalaxyFormFieldModule,
    ContainsValidDynamicContentDirective,
  ],
})
export class HtmlBlockComponent implements AfterViewInit, OnDestroy {
  @HostBinding('class') class = 'email-html-block';
  @Input() content: HtmlBlock;
  @ViewChild('blockInputs') blockInputs: NgForm;
  @Output() isBlockValid = new EventEmitter<boolean>();

  private readonly subscriptions: Subscription[] = [];

  constructor(private emailPreview: EmailPreviewRefreshService) {}

  ngAfterViewInit(): void {
    this.subscriptions.push(
      this.blockInputs.form.valueChanges.subscribe(() => {
        this.emailPreview.refresh();
      }),
      this.blockInputs.statusChanges.subscribe((status) => {
        this.isBlockValid.emit(status === 'VALID');
      }),
    );
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
